<template>
  <form-item-wrapper
    :designer="designer"
    :field="field"
    :design-state="designState"
    :parent-widget="parentWidget"
    :parent-list="parentList"
    :index-of-parent-list="indexOfParentList"
    :sub-form-row-index="subFormRowIndex"
    :sub-form-col-index="subFormColIndex"
    :sub-form-row-id="subFormRowId"
  >
    <van-field
      ref="fieldEditor"
      v-model="fieldModel"
      :rows="field.options.rows"
      :name="field.options.name"
      :label="fieldLabel"
      :label-align="field.options.labelAlign"
      :input-align="field.options.inputAlign"
      :label-width="fieldLabelWidth"
      :rules="rules"
      :disabled="fieldDisabled"
      :readonly="field.options.readonly || isReadMode"
      :required="field.options.required"
      :size="size"
      type="textarea"
      :placeholder="field.options.placeholder"
      :maxlength="field.options.maxLength"
      :show-word-limit="field.options.showWordLimit"
      :clearable="field.options.clearable"
      @focus="handleFocusCustomEvent"
      @blur="handleBlurCustomEvent"
      @change="handleChangeEvent(fieldModel)"
      @update:model-value="handleInputCustomEvent"
    >
    </van-field>
  </form-item-wrapper>
</template>

<script>
import { inject, toRefs, reactive, onMounted, onBeforeUnmount } from 'vue';
import { useI18n } from '@/utils/i18n';
import { useField } from '@/components/form-designer/form-widget/field-widget/fieldMixin';
import FormItemWrapper from '@/components/form-designer/form-widget/field-widget/form-item-wrapper';

export default {
  componentName: 'FieldWidget',
  components: {
    FormItemWrapper,
  },
  name: 'm-textarea-widget',
  props: {
    designState: {
      default: false,
      type: Boolean,
    },
    designer: Object,
    field: Object,
    indexOfParentList: Number,
    parentList: Array,

    parentWidget: Object,

    subFormColIndex: {
      default: -1,
      /* 子表单组件列索引，从0开始计数 */
      type: Number,
    },
    subFormRowId: {
      default: '',
      /* 子表单组件行Id，唯一id且不可变 */
      type: String,
    },
    subFormRowIndex: {
      default: -1,
      /* 子表单组件行索引，从0开始计数 */
      type: Number,
    },
  },
  setup(props) {
    const refList = inject('refList');
    const globalOptionData = inject('globalOptionData');
    const globalModel = inject('globalModel');

    const { i18nt } = useI18n();

    const data = reactive({
      fieldModel: null,
      noChangeEventFlag: true, //van-field组件没有change事件！！
      oldFieldValue: null, //field组件change之前的值

      rules: [],
    });
    const fieldMixin = useField(data);

    onMounted(() => {
      fieldMixin.handleOnMounted();
    });

    onBeforeUnmount(() => {
      fieldMixin.unregisterFromRefList();
    });

    // 增加最小长度校验
    const buildTextareaRules = () => {
      if (props.field.options.minLength && props.field.options.minLength > 0) {
        data.rules.push({
          message: i18nt('designer.hint.minTextLengthError').replace(/\{minLength}/, props.field.options.minLength),
          trigger: ['blur'],
          validator: val => val.length >= props.field.options.minLength,
        });
      }
    };
    fieldMixin.registerToRefList();
    fieldMixin.initFieldModel();
    fieldMixin.initEventHandler();
    fieldMixin.buildFieldRules();
    buildTextareaRules();

    fieldMixin.handleOnCreated();

    return {
      i18nt,
      ...fieldMixin,
      ...toRefs(data),
    };
  },
};
</script>

<style scoped></style>
